import React from "react";
import clsx from 'clsx';
import { SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const blockStyles = makeStyles(theme => ({
  root: {
    width: 24,
    height: 24
  }
}));

const IcClose = (props) => {

  const classes = blockStyles();
  const { className } = props;

  return (
    <SvgIcon className = { clsx(classes.root, className) }
             viewBox = { "0 0 24 24" } >
      <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#D5D5D5"/>
    </SvgIcon>
  );
}

export default IcClose;

